import type { MailboxInfo } from 'owa-client-types';
import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';

// This function should only be used to set initial context, hence the name
// The account selector is going to handle the logic internally and
// independently (by UI interaction) after the initial set up
/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
export const setInitialAccountSelectorMailboxInfo: (mailboxInfo: MailboxInfo) => void =
    mutatorAction('setInitialAccountSelectorMailboxInfo', (mailboxInfo: MailboxInfo): void => {
        getStore().accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
        getStore().sourceId = mailboxInfo.sourceId;
    });
